<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card>
            <b-row class="mb-3">
              <b-col cols="6" class="mt-1">
                <h4>Jira issues</h4>
              </b-col>
            </b-row>
            <div v-if="spinners.contentIsLoading" class="text-center">
              <b-spinner type="grow" variant="primary"/>
            </div>
            <div v-else>
              <b-row>
                <b-col cols="12">
                  <b-table
                        class="table-sm
                        text-center table-responsive" responsive bordered :fields="tableFields" :items="tableItems">
                  </b-table>
                </b-col>
              </b-row>
              <b-row>
                <!--Paginator-->
                <b-col cols="12" v-if="tableItems.length">
                  <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange"/>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Pagination from 'laravel-vue-pagination';
import statuses from '../../../store/statuses';
import JiraTypes from '@/store/modules/Jira/types';

export default {
  mounted() {
    this.getData();
  },
  props: ['page'],
  data() {
    return {
      spinners: {
        contentIsLoading: true,
      },
      row: {},
      tableFields: [
        { key: 'id', label: 'id' },
        { key: 'jira_id', label: 'jira_id' },
        { key: 'jira_key', label: 'jira_key' },
        { key: 'type', label: 'type' },
        { key: 'summary', label: 'summary' },
        { key: 'jira_created', label: 'jira_created' },
        { key: 'jira_project_id', label: 'jira_project_id' },
        { key: 'jira_issue_parent_id', label: 'jira_issue_parent_id' },
        { key: 'priority', label: 'priority' },
        { key: 'resolution', label: 'resolution' },
        { key: 'epic', label: 'epic' },
        { key: 'timespent', label: 'timespent' },
        { key: 'timeestimate', label: 'timeestimate' },
        { key: 'timeoriginalestimate', label: 'timeoriginalestimate' },
        { key: 'progress_percent', label: 'progress_percent' },
      ],
      tableItems: [],
    };
  },
  components: {
    Pagination
  },
  computed: {
    ...mapGetters('Jira', [
      'jiraIssues',
    ]),
    listPaginator() {
      return this.jiraIssues.data.meta;
    },
    list() {
      return this.jiraIssues;
    }
  },
  watch: {
    page: 'getData',
    listPaginator: {
      handler: function () {
        if (this.listPaginator && this.listPaginator.last_page < this.page) {
          this.onPageChange(this.listPaginator.last_page);
        }
      },
      deep: true
    },
    list: {
      handler: function () {
        console.log(this.list['status'] === statuses.LOADED);
        if (this.list['status'] === statuses.LOADED) {
          this.tableItems = this.list.data.data || [];
          this.spinners.contentIsLoading = false;
        }
      },
      deep: true
    },
    jiraIssuesUpdate: {
      handler: function () {
        if (this.jiraIssuesUpdate.status === statuses.LOADED) {
          // this.alertSuccess();
          this.getData();
        } else if (this.jiraIssuesUpdate.status === statuses.ERROR) {
          // this.alertError();
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('Jira', [
      JiraTypes.JIRA_ISSUES,
    ]),
    getData() {
      this.JIRA_ISSUES(this.page);
    },
    onPageChange(page) {
      if (!page) {
        page = this.page;
      }
      if (page !== this.page) {
        this.$router.push({ name: 'ApplyJiraIssues', params: { page } });
      }
    },
  }
};
</script>

<style scoped>
</style>
